import { useState } from 'react';
import { useAppDispatch } from '../redux/hooks';
import { forceLoginAgain } from '../redux/reducers/authReducer';

export const useReloginFlow = () => {
  const dispatch = useAppDispatch();
  const [showReloginDialog, setShowReloginDialog] = useState(false);
  const [reloginMessage, setReloginMessage] = useState('');

  const triggerRelogin = (message: string) => {
    setReloginMessage(message);
    setShowReloginDialog(true);
  };

  const handleReloginConfirm = () => {
    setShowReloginDialog(false);
    dispatch(forceLoginAgain());
  };

  return {
    showReloginDialog,
    reloginMessage,
    triggerRelogin,
    handleReloginConfirm,
  };
};
